import React from "react";
import { Navigate } from "react-router-dom";
import { useIsAuthenticated } from "@/hooks/useIsAuthenticated";

interface AuthGuardProps {
  children: React.ReactNode;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const hasToken = useIsAuthenticated();

  if (!hasToken) {
    return <Navigate to="/login" replace />;
  }

  // We allow rendering children (like the Layout) if we have a token,
  // even if the profile is still loading.
  // The layout will use JWT role for its structure.
  return <>{children}</>;
};
